import React from 'react';
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton, PinterestShareButton, EmailShareButton } from "react-share";
import { FacebookIcon, TwitterIcon, WhatsappIcon, PinterestIcon, EmailIcon } from "react-share";
import { useTranslation } from 'react-i18next';
import '../../i18';

const ShareAppModal = ({isOpen, isClose, shareUrl, title}) => {
    const { t } = useTranslation();
    if (!isOpen) return null;
    return (
        <>
            <div
                className="modal fade show d-block modal-overlay"
                role="dialog"
                aria-labelledby="shareModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header border-0">
                            <h5 className="modal-title" id="shareModalLabel">
                                {t("shareThisContent")}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={isClose}
                            ></button>
                        </div>
                        <div className="modal-body text-center">
                            <p className='mb-5'>{t("shareVia")}</p>
                            <div className="d-flex justify-content-around">
                                <FacebookShareButton url={shareUrl} quote={title}>
                                    <FacebookIcon size={40} round />
                                </FacebookShareButton>
                                <TwitterShareButton url={shareUrl} title={title}>
                                    <TwitterIcon size={40} round />
                                </TwitterShareButton>
                                <WhatsappShareButton url={shareUrl} title={title}>
                                    <WhatsappIcon size={40} round />
                                </WhatsappShareButton>
                                <EmailShareButton url={shareUrl} title={title}>
                                    <EmailIcon size={40}/>
                                </EmailShareButton>
                            </div>
                        </div>
                        <div className="modal-footer border-0">
                            <button
                                type="button"
                                className="btn btn-border-black b-animate-3"
                                onClick={isClose}
                            >
                                {t("close")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ShareAppModal;